var map = {
	"./countbg1.png": "3d98",
	"./countbg2.png": "5eca",
	"./countbg3.png": "c75a",
	"./high-bg.png": "5ace",
	"./high-border.png": "a74e",
	"./low-bg.png": "8767",
	"./low-border.png": "76c6",
	"./middle-bg.png": "1b4d",
	"./middle-border.png": "c6cc",
	"./phone.png": "1de7",
	"./safe-bg.png": "0973",
	"./safe-border.png": "1359",
	"./vivo.png": "fb20",
	"./vivo1.png": "2891",
	"./vivo2.png": "ee51"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f25a";